import { useTranslation } from "react-i18next";
import { NeuSelect } from "../../components/neu/Neu";
import { Field } from "../../components/neu/Field";
import { IdentityFields } from "./IdentityFields";
import { EmergencyPhone } from "./EmergencyPhone";
import { SubHeading } from "./EmployeeFormSection";

const MARITAL = ["single", "married", "divorced", "widowed"];

export const EmployeePersonalFields = ({ personal, setPersonal, countries, rule, errors }) => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <SubHeading title={t("employees.form.sub.demographics")} testId="sub-demographics" />
      <div>
        <p className="label-xs mb-2">{t("personal.nationality")}</p>
        <NeuSelect
          data-testid="employee-nationality"
          value={personal.nationality || ""}
          onChange={(e) => setPersonal("nationality", e.target.value)}
        >
          <option value="">{t("personal.selectCountry")}</option>
          {countries.map((c) => (
            <option key={c.code} value={c.code}>
              {i18n.language === "ar" ? c.ar : c.en}
            </option>
          ))}
        </NeuSelect>
      </div>
      <Field label={t("personal.birthDate")} testId="employee-birthdate" type="date" value={personal.birth_date || ""} onChange={(v) => setPersonal("birth_date", v)} />
      <div>
        <p className="label-xs mb-2">{t("personal.gender")}</p>
        <NeuSelect data-testid="employee-gender" value={personal.gender || ""} onChange={(e) => setPersonal("gender", e.target.value)}>
          <option value="">—</option>
          <option value="male">{t("personal.male")}</option>
          <option value="female">{t("personal.female")}</option>
        </NeuSelect>
      </div>
      <div>
        <p className="label-xs mb-2">{t("personal.marital")}</p>
        <NeuSelect data-testid="employee-marital" value={personal.marital_status || ""} onChange={(e) => setPersonal("marital_status", e.target.value)}>
          <option value="">—</option>
          {MARITAL.map((m) => (
            <option key={m} value={m}>{t(`personal.maritalOptions.${m}`)}</option>
          ))}
        </NeuSelect>
      </div>

      <SubHeading title={t("employees.form.sub.identityDocs")} testId="sub-identity-docs" />
      <IdentityFields personal={personal} setPersonal={setPersonal} rule={rule} errors={errors} />

      <SubHeading title={t("employees.form.sub.emergency")} testId="sub-emergency" />
      <Field label={t("personal.emergencyName")} testId="employee-emergency-name" value={personal.emergency_name || ""}
             onChange={(v) => setPersonal("emergency_name", v.replace(/[0-9\u0660-\u0669]/g, ""))} />
      <EmergencyPhone label={t("personal.emergencyPhone")} value={personal.emergency_phone || ""}
             onChange={(v) => setPersonal("emergency_phone", v)} />
      <div className="sm:col-span-2 lg:col-span-3">
        <Field label={t("personal.address")} testId="employee-address" value={personal.address || ""} onChange={(v) => setPersonal("address", v)} />
      </div>
    </>
  );
};
